import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Constant } from 'app/config/constants';
import { UserService } from 'app/core/user/user.service';
import { DialogService } from 'app/service/dialog.service';
import { AppState } from 'app/store/app.state';
import { ToastrService } from 'ngx-toastr';
import { DialogMessageComponent } from '../dialog-message/dialog-message.component';
import { Helper as CommonHelper } from 'app/common/helper';

@Component({
  selector: 'dialog-change-password',
  templateUrl: './dialog-change-password.component.html',
  styleUrls: ['./dialog-change-password.component.scss']
})
export class DialogChangePasswordComponent implements OnInit {
  @ViewChild('btnSaveChangePassword') changePassword: ElementRef;
  /**
   * new password
   */
  newPassword: string = '';
  /**
   * confirm password
   */
  confirmedPassword: string = '';
  isCurrentUser: boolean;

  constructor(
    private dialogService: DialogService,
    private dialogRef: MatDialogRef<DialogChangePasswordComponent>,
    private userService: UserService,
    private toast: ToastrService,
    public readonly store: Store<AppState>,
    private translateService: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.isCurrentUser = data.isCurrentUser;
  }

  async ngOnInit(): Promise<void> {
    await this.getEndPoint();
  }

  /**
   * save change password
   */
  public async saveChangePassword(): Promise<void> {
    if (this.newPassword != this.confirmedPassword) {
      this.dialogService.showDialog(
        DialogMessageComponent,
        {
          data: {
            title: this.translateService.instant('dialog-change-password.msg.title-error'),
            text: this.translateService.instant('dialog-change-password.msg.password-not-match')
          }
        },
        () => {
          this.changePassword.nativeElement.blur();
        }
      );
      return;
    }

    const payload = {
      username: this.data.sub,
      password: this.newPassword,
      permanent: this.isCurrentUser
    };

    // change password
    this.userService.changePassword(payload).subscribe(
      () => {
        this.toast.success(this.translateService.instant('dialog-change-password.msg.change-password-success'), '');
        this.dialogRef.close();
      },
      error => {
        let msg = this.translateService.instant('dialog-change-password.msg.other-error');
        if (error.status == Constant.BAD_REQUEST_ERROR_CODE) {
          msg = this.translateService.instant('dialog-change-password.msg.bad_request_error');
        } else if (error.status == Constant.FORBIDDEN_ERROR_CODE) {
          msg = this.translateService.instant('dialog-change-password.msg.forbidden-error');
        } else if (error.status == Constant.NETWORK_ERROR_CODE) {
          msg = this.translateService.instant('dialog-change-password.msg.error-network');
        }
        this.dialogService.showDialog(
          DialogMessageComponent,
          {
            data: {
              title: this.translateService.instant('dialog-change-password.msg.title-error'),
              text: msg
            }
          },
          () => {
            this.changePassword.nativeElement.blur();
          }
        );
      }
    );
  }

  /**
   * getEndPoint
   */
  async getEndPoint(): Promise<void> {
    try {
      const res = await this.userService.getEndPoint().toPromise();
      const mapRes = new Map<string, string>(Object.entries(res));
      this.userService.setEndPoint(mapRes);
    } catch (error) {
      error => CommonHelper.handleError(error, this.translateService, this.dialogService);
      throw error;
    }
  }
}
